<template>
  <!-- 耕雲導師詩歌及語法 -->
  <div class="taoist">
    <div v-for="(item, index) in content" :key="index">
      <div class="flex-between title">
        <div class="titleLeft oneLine">{{ item.cate_name }}</div>
<!--        <div-->
<!--          v-show="item.lists.length > 3"-->
<!--          class="expand flex-start"-->
<!--          @click="changShowList(index)"-->
<!--        >-->
<!--          &lt;!&ndash; 展开收起按钮 &ndash;&gt;-->
<!--          <div v-if="!contentStatus[index]" class="flex-center openBtn">-->
<!--            <div>{{ $t("downBtn") }}</div>-->
<!--            <div class="down">-->
<!--              <img src="../../static/img/down.png" alt />-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-if="contentStatus[index]" class="flex-center openBtn">-->
<!--            <div>{{ $t("upBtn") }}</div>-->
<!--            <div class="down">-->
<!--              <img src="../../static/img/up.png" alt />-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>

      <!-- 二级列表 -->
      <div >
        <div
            class="content flex-between"
            v-for="(item1, index1) in item.lists"
            :key="index1"
        >
          <div @click="linkToDetail(item1)">
            {{ index1 + 1 }}、{{ item1.audio_title }}
          </div>
          <div v-if="item1.songflag" class="color04" @click="linkToSongDetail(item1)">
            {{ $t("song") }}
          </div>
        </div>
      </div>
<!--      <div v-if="item.lists.length <= 3 || contentStatus[index]">-->
<!--        <div-->
<!--          class="content flex-between"-->
<!--          v-for="(item1, index1) in item.lists"-->
<!--          :key="index1"-->
<!--        >-->
<!--          <div @click="linkToDetail(item1)">-->
<!--            {{ index1 + 1 }}、{{ item1.audio_title }}-->
<!--          </div>-->
<!--          <div v-if="item1.songflag" class="color04" @click="linkToSongDetail(item1)">-->

<!--            {{ $t("song") }}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div v-else>-->
<!--        <div class="content flex-between">-->
<!--          <div @click="linkToDetail(item.lists[0])">-->
<!--            {{ 1 }}、{{ item.lists[0].audio_title }}-->
<!--          </div>-->
<!--          &lt;!&ndash; 禅曲 &ndash;&gt;-->
<!--          <div-->
<!--            v-if="item.lists[0].songflag"-->
<!--            class="color04"-->
<!--            @click="linkToSongDetail(item.lists[0])"-->
<!--          >-->
<!--            {{ $t("song") }}-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="content flex-between">-->
<!--          <div @click="linkToDetail(item.lists[1])">-->
<!--            {{ 2 }}、{{ item.lists[1].audio_title }}-->
<!--          </div>-->
<!--          <div-->
<!--            v-if="item.lists[1].songflag"-->
<!--            class="color04"-->
<!--            @click="linkToSongDetail(item.lists[1])"-->
<!--          >-->
<!--            {{ $t("song") }}-->
<!--          </div>-->
<!--        </div>-->
<!--        <point></point>-->
<!--        <div class="content flex-between">-->
<!--          <div @click="linkToDetail(item.lists[item.lists.length - 1])">-->
<!--            {{ item.lists.length }}、{{-->
<!--              item.lists[item.lists.length - 1].audio_title-->
<!--            }}-->
<!--          </div>-->
<!--          <div-->
<!--            class="color04"-->
<!--            @click="linkToSongDetail(item.lists[item.lists.length - 1])"-->
<!--            v-if="item.lists[item.lists.length - 1].songflag"-->
<!--          >-->
<!--            {{ $t("song") }}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <barF5></barF5>
    </div>
  </div>
</template>

<script>
import point from "../../components/point";
import barF5 from "../../components/barF5";
import { getCateList, getPoetry } from "../../api/apis";
export default {
  name: "",
  components: {
    point,
    barF5,
  },
  props: {
    // content: {
    //     type: Array,
    //     default: () => {}
    // },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      contentStatus: [false, false, false], //控制展开和结束
      content: [],
      // content: [
      //     {
      //         title: "(一) 詩 歌",
      //         list: [
      //             {
      //                 id: 1,
      //                 name: "詩 歌1",
      //                 song: 2
      //             },
      //             {
      //                 id: 1,
      //                 name: "詩 歌2",
      //                 song: 2
      //             },
      //             {
      //                 id: 1,
      //                 name: "詩 歌3",
      //                 song: 2
      //             }
      //         ]
      //     }
      // ]
    };
  },
  watch: {
    content() {
      //初始化contentStatus
      let array = [];
      let length = this.content.length;
      for (let i = 0; i < length; i++) {
        array[i] = false;
      }
      this.contentStatus = array;
    },
  },
  methods: {
    changShowList(index) {
      this.contentStatus.splice(index, 1, !this.contentStatus[index]);
      
      
    },
    //文章详情
    linkToDetail(item) {
      this.$router.push({
        path: "/articleDetail",
        query: { name: "poetry", id: item.id, title: this.title },
      });
    },
    //歌曲详情
    linkToSongDetail(item) {
       if (item.new_link_mobile) {
        window.open(item.new_link_mobile);
      } else {
        this.$router.push({
          path: "/musicDetail",
          query: { name: "poetry", id: item.id, title: this.title },
        });
      }
      // this.$router.push({
      //   path: "/musicDetail",
      //   query: { name: "poetry", id: item.id, title: this.title },
      // });
    },
  },
  created() {
    getCateList().then((res) => {
      getPoetry(res[1][3].id).then((res) => {
        this.content = res || [];
        console.log(this.content)
        
        this.content.map((item)=>{
            item.lists.map((item1)=>{
                if(item1.audio_url != ''){
                    item1.songflag = true
                }else{
                    item1.songflag = false
                }
            })
        })
      });
    });
  },
};
</script>

<style scoped>
.taoist {
  color: #333333;
}

.title {
  padding: 0.64rem;
}

.titleLeft {
  font-size: 0.8rem;
  line-height: 1.8rem;
  font-size: 0.85rem;
  font-weight: 600;
  width: 12rem;
}

.content {
  /* height: 2.4rem; */
  border-top: 1px dashed #dfdfdf;
  line-height: 1.8rem;
  padding-left: 0.64rem;
  padding-right: 0.64rem;
  font-size: 0.85rem;
}

/* .expand {
    font-size: 0.69rem;
    width: 3.6rem;
  } */
.openBtn {
  width: 4rem;
  flex-shrink: 0;
}

.down img {
  width: 0.64rem;
  height: 0.32rem;
  margin-left: 0.2rem;
}

.color04 {
  color: #047bcd;
}
</style>